<template>
  <div class="NewMain">
    <main>
      <div class="newmain_con">
        <div class="newmain_top clearhegt">
          <h1 class="newmain_top_title">{{maintitleA}}</h1>
          <p class="newmain_top_title2">{{subtitleA}}</p>
          <div class="newmain_top_left" >
            <div class="newmain_top_left_img">
              <img :src='exteion[0].image' alt />
            </div>
            <div class="newmain_top_left_title">
              <span class="newmain_top_left_title1">{{exteion[1].title}}</span>
              <span class="newmain_top_left_title2">{{exteion[1].contents}}</span>
            </div>
          </div>
          <div class="newmain_top_right">
            <div class="newmain_top_right_title">
              <span class="newmain_top_right_title1">{{exteion[0].title}}</span>
              <span class="newmain_top_right_title2">{{exteion[0].contents}}</span>
            </div>
            <div class="newmain_top_right_img">
              <img :src="exteion[1].image" alt />
            </div>
          </div>
          <div class="newmain_top_bom">
            <div class="newmain_top_bom_left">
              <img :src='exteion[2].image' alt />
            </div>
            <div class="newmain_top_bom_right">
              <span class="newmain_top_left_title1 title1">{{exteion[2].title}}</span>
              <span
                class="newmain_top_left_title2 title2"
              >{{exteion[2].contents}}</span>
            </div>
          </div>
        </div>
        <div class="newmain_cen">
          <h1 class="newmain_cen_title h1title">{{maintitleC}}</h1>
          <p class="ptitle">{{subtitleC}}</p>
          <div class="newmain_cen_con">
            <ul class="newmain_cen_con_list">
              <li v-for="item in ud_datas" :key="item.image">
                <div class="newmain_cen_itemImg">
                  <img :src="item.image" alt />
                  <p class="newmain_cen_itemTitle">{{item.title}}</p>
                  <p class="newmain_cen_itemTitle2">{{item.content}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="newmain_bom">
          <div class="newmain_bom_con">
            <h1 class="h1title">{{this.$store.state.siteName}}-你的个人流量变现神器</h1>
            <p class="ptitle">个人流量变现神器 企业同城推广好帮手</p>
            <div class="newmain_bom_con_main">
              <ul>
                <li>
                  <div class="newmain_bom_con_itemImg">
                    <img src="../../../assets/slices/con_itemImg1.png" alt />
                  </div>
                  <div class="newmain_bom_con_itemImgauto">
                    <img src="../../../assets/slices/con_itemImg2.png" alt />
                    <p>公众号</p>
                  </div>
                </li>
                <li>
                  <div class="newmain_bom_con_itemImg">
                    <img src="../../../assets/slices/con_itemImg3.png" alt />
                  </div>
                  <div class="newmain_bom_con_itemImgauto">
                    <img src="../../../assets/slices/con_itemImg4.png" alt />
                    <p>小程序</p>
                  </div>
                </li>
                <li>
                  <div class="newmain_bom_con_itemImg">
                    <img src="../../../assets/slices/con_itemImg5.png" alt />
                  </div>
                  <div class="newmain_bom_con_itemImgauto">
                    <img src="../../../assets/slices/con_itemImg6.png" alt />
                    <p>PC端</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="chang_but">
              <div class="chang_but_lef backurl" @click="changsee()" :class="see==true ? 'changback' : ' changback2'">
                <p>企业</p>
              </div>
              <div class="chang_but_rig backurl" @click="changsee2()" :class="see==false ? 'changback3' : ' '">
                <p>达人</p>
              </div>
            </div>
          </div>
        </div>
        <div class="newmain_introduce">

          <el-carousel class="newmain_introduce_cen" arrow="always" v-show="this.see">
        <el-carousel-item class="" v-for="(item,i) in users" :key="item[i]" >
          <div class="newmain_introduce_cen_lef newmain_introduce_cen_but">
              <div>
                <img src="../../../assets/slices/introduceImg.png" alt />
              </div>
            </div>
            <ul class="newmain_introduce_list">
              <li>
                <!-- <div class="newmain_introduce_cen_rig"></div> -->
                <div class="newmain_introduce_userImg"><img :src="item.head_img" alt=""></div>
                <h1 class="newmain_introduce_title">{{item.main_title}}</h1>
                <p class="newmain_introduce_title2">{{item.sub_title}}</p>
                <span>{{item.content}}</span>
              </li>
            </ul>
        </el-carousel-item>
      </el-carousel>

    <el-carousel class="newmain_introduce_cen changnone" arrow="always" v-show="this.see2">
        <el-carousel-item class="" v-for="(item,i) in users3" :key="item[i]">
          <div class="newmain_introduce_cen_lef newmain_introduce_cen_but">
              <div>
                <img src="../../../assets/slices/introduceImg.png" alt />
              </div>
            </div>
            <ul class="newmain_introduce_list">
              <li>
                <!-- <div class="newmain_introduce_cen_rig"></div> -->
                <div class="newmain_introduce_userImg"><img :src="item.head_img" alt=""></div>
                <h1 class="newmain_introduce_title">{{item.main_title}}</h1>
                <p class="newmain_introduce_title2">{{item.sub_title}}</p>
                <span>{{item.content}}</span>
              </li>
            </ul>
        </el-carousel-item>
      </el-carousel>

        </div>
        <div class="newmain_logo">
          <div class="newmain_logo_cen">
            <h1 class="h1title">{{maintitle}}</h1>
            <p class="ptitle" >{{subtitle}}</p>
            <div class="newmain_logo_Img">
              <ul>
                <li v-for="(item,index) in logoimg" :key="index">
                  <img :src="item" alt />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {
  gethomepc
} from "@/config/api.js";
export default {
  name: "NewMain",
  data() {
    return {
      exteion:[
        {
          title:null,
          contents:'',
          image:'',
        },{
          title:null,
          contents:'',
          image:'',
        },{
          title:null,
          contents:'',
          image:'',
        }
      ],
      ud_datas:[],
      users:[],
      users3:[],
      users4:[],
      users2:[],
      see:true,
      see2:false,
      logoimg:[],
      // ____________
      // 底部友情链接数据
      // fotercon:[],//
      // friendship:[],//
      // foter_logo:[],//
      // logo标题
      maintitle:{},
      subtitle:{},
      maintitleA:'',
      maintitleB:'',
      maintitleC:'',
      subtitleA:'',
      subtitleB:'',
      subtitleC:'',
    }
  },
  methods:{
    // goto2(i){
    //   window.open('http://'+this.friendship[i].url);
    // },
    changsee(){
      this.see=true;
      this.see2=false;
    },
    changsee2(){
      this.see2=true;
      this.see=false;
    },
    getInfo() {
      this.$post(gethomepc,{key:'pc_home_page'})
        .then(res => {
          let data = JSON.parse(res.data);
          this.maintitleA=data.lr_data.main_title;
          this.maintitleB=data.partner.main_title;
          this.maintitleC=data.ud_data.main_title;
          this.subtitleA=data.lr_data.sub_title;
          this.subtitleB=data.partner.sub_title;
          this.subtitleC=data.ud_data.sub_title;
          let {lr_data} = data;
          for(let i =0;i<this.exteion.length;i++)
          {
            this.exteion[i].title = lr_data.data[i].title;
            this.exteion[i].contents = lr_data.data[i].content;
            this.exteion[i].image = lr_data.data[i].image;
            if(this.exteion[i].title == '') break;
          }
          for(let i = 0;i<data.ud_data.data.length;i++)
          {
            this.ud_datas.push(data.ud_data.data[i])
          }
          // 底部企业达人数据
          let {ep_user} = data.introduct;
          let {ps_user} = data.introduct;
          for(let i = 0; i < ep_user.length;i++)
          {
            this.users.push(ep_user[i])
          }
          for(let i = 0; i< ps_user.length;i++)
          {
            this.users3.push(ps_user[i])
          }
      // fotercon:[],//
      // friendship:[],//
      // foter_logo:[],//
          // 底部友情链接数据
          // this.fotercon.push(data.bottom.logo)
          // let {bottom} = data;
          // this.foter_logo.push(bottom.first_qrcode);
          // this.foter_logo.push(bottom.second_qrcode);
          // let {link} = data.bottom
          // for(let i=0;i<link.length;i++){
          //   this.friendship.push(link[i])
          // }
          // 底部多 logo图 title
          let {logo} = data.partner;
          // this.logoimg.push(data.partner);
          for(let i = 0; i< logo.length;i++)
          {
            this.logoimg.push(logo[i])
          }
          this.maintitle = data.partner.main_title;
          this.subtitle = data.partner.sub_title;
            // console.log(data.bottom.logo)
        })
        .catch(err => {
          window.console.log(err);
        });
    },
  },
  mounted(){
    this.getInfo();
  }
};
</script>

<style>
  p, span, a, div, i{font-family:Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;}
.newmain_introduce .el-carousel__item.is-animating{
  transition: transform .0s ease-in-out, -webkit-transform .0s ease-in-out !important;
}
.NewMain {
  width: 100%;
  /* height: 5039px; */
}
.NewMain main {
  width: 100%;
  /* height: 4652px; */
}
.NewMain .newmain_con {
  width: 1200px;
  /* height: 5039px; */
  margin: 0 auto;
  /* background: #000; */
}
.NewMain .newmain_con .newmain_top {
  width: 100%;
  /* height: 1780px; */
  /* background: firebrick; */
}
.clearhegt{
  clear:both;
  overflow: hidden;
}
.NewMain .newmain_con .newmain_cen {
  width: 1200px;
  height: 970px;
  box-sizing: border-box;
}
.NewMain .newmain_con .newmain_top .newmain_top_title {
  height: 35px;
  font-size: 26px;
  font-weight: bold;
  line-height: 35px;
  color: rgba(41, 41, 41, 1);
  opacity: 1;
  text-align: center;
}
.NewMain .newmain_con .newmain_top p {
  text-align: center;
  height: 18px;
  font-size: 14px;
  line-height: 18px;
  color: #666;
  opacity: 1;
  margin-top: 10pt;
}
.NewMain .newmain_con .newmain_top .newmain_top_left {
  width: 641px;
  height: 1178px;
  /* background: #000; */
  /* background: linear-gradient(
    180deg,
    rgba(236, 244, 255, 1) 0%,
    rgba(250, 253, 255, 1) 100%
  ); */
  background: url('../../../assets/images/backurl.png') 0 0 no-repeat;
  opacity: 1;
  float: left;
}
.NewMain .newmain_con .newmain_top .newmain_top_left .newmain_top_left_img {
  width: 500px;
  height: 500px;
  margin: 88px 0 0 40px;
}
.NewMain .newmain_con .newmain_top .newmain_top_left .newmain_top_left_img img {
  width: 500px;
  height: 500px;
}
.NewMain .newmain_con .newmain_top .newmain_top_left .newmain_top_left_title {
  height: 135px;
  width: 231px;
  margin: 264px 0 0 160px;
}
.NewMain .newmain_con .newmain_top .newmain_top_left .newmain_top_left_title1 {
  float: right;
  height: 45px;
  font-size: 34px;
  font-weight: 400;
  line-height: 56px;
  color: rgba(54, 55, 61, 1);
  opacity: 1;
}
.NewMain .newmain_con .newmain_top .newmain_top_left .newmain_top_left_title2 {
  margin-top: 20px;
  float: left;
  width: 231px;
  height: 65px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(102, 102, 102, 1);
  opacity: 1;
  text-align: right;
}
.title1 {
  float: right;
  height: 45px;
  font-size: 34px;
  font-weight: 400;
  line-height: 56px;
  color: rgba(54, 55, 61, 1);
  opacity: 1;
}
.title2 {
  margin-top: 20px;
  float: left;
  width: 231px;
  height: 65px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(102, 102, 102, 1);
  opacity: 1;
}
.NewMain .newmain_con .newmain_top .newmain_top_right {
  width: 500px;
  height: 1178px;
  float: right;
}
.NewMain .newmain_con .newmain_top .newmain_top_right .newmain_top_right_title {
  height: 135px;
  width: 231px;
  margin: 272px 0 0 149px;
}
.NewMain
  .newmain_con
  .newmain_top
  .newmain_top_right
  .newmain_top_right_title
  .newmain_top_right_title1 {
  height: 45px;
  font-size: 34px;
  font-weight: 400;
  line-height: 56px;
  color: rgba(54, 55, 61, 1);
  opacity: 1;
  float: right;
}
.NewMain
  .newmain_con
  .newmain_top
  .newmain_top_right
  .newmain_top_right_title
  .newmain_top_right_title2 {
  width: 231px;
  height: 65px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(102, 102, 102, 1);
  opacity: 1;
  float: left;
  margin-top: 20px;
}
.NewMain .newmain_con .newmain_top .newmain_top_right .newmain_top_right_img {
  width: 500px;
  height: 500px;
  margin-top: 265px;
}
.NewMain
  .newmain_con
  .newmain_top
  .newmain_top_right
  .newmain_top_right_img
  img {
  width: 500px;
  height: 500px;
}
.newmain_top_bom {
  width: 100%;
  height: 500px;
  float: left;
}
.NewMain .newmain_con .newmain_top_bom_left {
  width: 500px;
  height: 500px;
  margin-left: 40px;
  float: left;
}
.NewMain .newmain_con .newmain_top_bom_left img {
  width: 500px;
  height: 500px;
}
.NewMain .newmain_con .newmain_top_bom_right {
  height: 135px;
  width: 231px;
  float: right;
  margin: 185px 120px 0 0;
}
.h1title {
  height: 35px;
  font-size: 26px;
  font-weight: bold;
  line-height: 35px;
  color: rgba(41, 41, 41, 1);
  opacity: 1;
  text-align: center;
}

.ptitle {
  text-align: center;
  height: 18px;
  font-size: 14px;
  line-height: 18px;
  color: rgba(102, 102, 102, 1);
  opacity: 1;
  margin-top: 10pt;
}
.newmain_cen_con {
  width: 760px;
  height: 582px;
  margin: 80px auto;
}
.newmain_cen_con .newmain_cen_con_list {
  width: 843px;
  height: 582px;
  display: flex;
 flex-wrap: wrap;
justify-content: space-between;
align-items:baseline;
}

.newmain_cen_con li {
  width: 284px;
  height: 251px;
  margin-bottom: 80px;

}

* {
  box-sizing: border-box;
}
.newmain_cen_con li .newmain_cen_itemImg {
  width: 160px;
  height: 160px;
  margin: 0 0 0 16px;
}
.newmain_cen_con li img {
  width: 160px;
  height: 160px;
}
.newmain_cen_itemTitle {
  text-align: center;
  height: 26px;
  font-size: 20px;
  font-weight: bold;
  line-height: 26px;
  color: rgba(41, 41, 41, 1);
  opacity: 1;
  margin-top:10px;
}
.newmain_cen_itemTitle2 {
  text-align: center;
  height: 40px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(102, 102, 102, 1);
  opacity: 1;
  margin-top: 15px;
}
.newmain_cen_con .newmain_cen_con_list2 {
  float: right;
  width: 192px;
  height: 582px;
}
.newmain_bom {
  width: 1200px;
  height: 825px;
  margin: 0 auto;
}
.newmain_bom_con {
  width: 900px;
  height: 825px;
  margin: 0 auto;
}
.newmain_bom_con_main {
  margin-top: 80px;
  width: 900px;
  height: 352px;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: space-between;
  justify-content: space-between;
  margin-bottom: 235px;
}
.newmain_bom_con_main ul {
  width: 900px;
  height: 352px;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: space-between;
  justify-content: space-between;
}
.newmain_bom_con_main ul li {
  position: relative;
  width: 290px;
  height: 352px;
}
.newmain_bom_con_main ul li .newmain_bom_con_itemImg {
  width: 290px;
  height: 352px;
}
.newmain_bom_con_main ul li .newmain_bom_con_itemImg img {
  width: 290px;
  height: 352px;
}
.newmain_bom_con_main ul li .newmain_bom_con_itemImgauto {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80px;
  height: 110px;
  margin: -55px 0 0 -40px;
}
.newmain_bom_con_main ul li .newmain_bom_con_itemImgauto img {
  width: 80px;
  height: 80px;
}
.newmain_bom_con_main ul li .newmain_bom_con_itemImgauto p {
  text-align: center;
  height: 26px;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
}
.newmain_bom .newmain_bom_con .chang_but {
  margin: auto;
  width: 290px;
  height: 91px;
}
.newmain_bom .newmain_bom_con .chang_but .chang_but_lef {
  display: block;
  cursor: pointer;
  padding-top: 10px;
  text-align: center;
  width: 142px;
  height: 91px;
  float: left;
  background: url("../../../assets/slices/focuesbut.png") 0 0 no-repeat;
}
/* qiehuan */
.changback{
  background: url("../../../assets/slices/focuesbut.png") 0 0 no-repeat !important;
}
.changback3{
  background: url("../../../assets/slices/butback.png") 0 0 no-repeat !important;
}
.changback3 p{
  color: #fff !important;
}
.changback p{
  color: #fff !important;
}
.changback2{
  background: url("../../../assets/slices/righbut.png") 0 0 no-repeat !important;
}
.changback2 p{
  color: rgba(184, 184, 184, 1) !important;

}
.newmain_bom .newmain_bom_con .chang_but .chang_but_lef:focus{
  /* background: url("../../../assets/首页1108_slices/组 1053.png") 0 0 no-repeat !important; */
  /* background: red !important; */
}
/* .newmain_bom .newmain_bom_con .chang_but .backurl{
  background: url("../../../assets/首页1108_slices/组 1053.png") 0 0 no-repeat;
} */
.newmain_bom .newmain_bom_con .chang_but .chang_but_rig {
  display: block;
  cursor: pointer;
  padding-top: 10px;
  text-align: center;
  width: 142px;
  height: 91px;
  float: right;
  background: url("../../../assets/slices/righbut.png") 0 0 no-repeat;
}
.newmain_bom .newmain_bom_con .chang_but .chang_but_lef p {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 46px;
  padding-left:10px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
}
.newmain_bom .newmain_bom_con .chang_but .chang_but_rig p {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  padding-left:10px;
  line-height: 46px;
  color: rgba(184, 184, 184, 1);
  opacity: 1;
}
.newmain_con .newmain_introduce {
  width: 1200px;
  height: 450px;
  margin: 0 auto;
  overflow: hidden;
}
.newmain_introduce_userImg{
  width: 60px;
  height: 60px;
  margin: 0 auto;
  margin-bottom: 8px;
}
.newmain_introduce_userImg img{
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.newmain_introduce .el-carousel__item {
  padding-top: 5px;
}
/* heqiwei  */
.newmain_introduce .newmain_introduce_cen {
  position: relative;
  /* padding: 108px 110px 0 110px; */
  width: 1200px;
  height: 455px;
  margin: 0 auto;
  /* box-shadow: 0px 5px 16px rgba(246, 246, 246, 1); */
  border-radius:6px;
  box-shadow:0px 5px 16px rgba(246,246,246,1);
}
.newmain_introduce .newmain_introduce_cen .el-carousel__container{
  height: 450px;
}
.newmain_introduce .el-carousel__arrow{
  width:50px;
  height:140px;
  background:rgba(255,255,255,1);
  opacity:1;
  border-radius:4px;
}
.newmain_introduce .el-carousel__arrow--right{
  right: 50px;
}
.newmain_introduce .el-carousel__arrow--left{
  left: 50px;
}
/*  */
.newmain_introduce .el-carousel__arrow:hover{
  background:rgba(240,240,240,1);
  opacity: 1;
}
.newmain_introduce .el-carousel__arrow i{
  font-size: 24px;
  color: #d8d8d8;
}
.newmain_introduce_cen .newmain_introduce_list{
  margin-top: 5px;
  /* border: 1px solid #000; */
  width: 900px;
  height: 400px;
  box-shadow:0px 5px 16px rgba(246,246,246,1);
  /* box-shadow:0px 5px 16px #000; */

  margin: 0 auto;
  text-align: center;
  padding: 27px 110px 0 110px;
 }
.newmain_introduce .newmain_introduce_cen .newmain_introduce_title {
  text-align: center;
  height: 21px;
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  color: rgba(41, 41, 41, 1);
  opacity: 1;
}
.newmain_introduce .newmain_introduce_cen .newmain_introduce_title2 {
  text-align: center;
  height: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(184, 184, 184, 1);
  opacity: 1;
  margin-bottom: 35px;
}
.newmain_introduce .newmain_introduce_cen span {
  height: 85px;
  font-size: 15px;
  font-weight: 400;
  line-height: 32px;
  color: rgba(122, 122, 122, 1);
  opacity: 1;
}
.NewMain
  .newmain_con
  .newmain_introduce
  .newmain_introduce_cen
  .newmain_introduce_cen_lef {
  position: absolute;
  left: -100px;
  width: 50px;
  height: 140px;
  /* background: rgba(240, 240, 240, 1); */
  /* heqiwei */
  background: red;
  opacity: 1;
  border-radius: 4px;
}

.el-carousel__indicators--horizontal{
  /* display: none; */
}
.changnone{
  /* display: none !important; */
}
.newmain_introduce .el-carousel__arrow:hover{
  background-color: rgba(31,45,61,.11);
}
.newmain_introduce .el-carousel__arrow:hover i{
  color: #7A7A7A;
}
/* .newmain_introduce .el-carousel--horizontal{
  overflow: visible !important;
} */

/* .newmain_introduce .el-carousel__arrow--left{
  left: -200px !important;
}
.newmain_introduce .el-carousel__arrow--right{
  right: -200px !important;
} */
.NewMain
  .newmain_con
  .newmain_introduce
  .newmain_introduce_cen
  .newmain_introduce_cen_rig {
  position: absolute;
  right: -100px;
  width: 50px;
  height: 140px;
  background: rgba(240, 240, 240, 1);
  opacity: 1;
  border-radius: 4px;
}
.NewMain
  .newmain_con
  .newmain_introduce
  .newmain_introduce_cen
  .newmain_introduce_cen_but
  div {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 44px;
  height: 44px;
}
.NewMain .newmain_con .newmain_logo {
    margin: auto;
  margin-top: 210px;
  width: 1200px;
  /* height: 648px; */
}
.NewMain .newmain_con .newmain_logo .newmain_logo_cen {
  width: 960px;
  /* height: 648px; */
  margin: 0 auto;
}
.NewMain .newmain_con .newmain_logo .newmain_logo_cen .newmain_logo_Img {
  margin-top: 80px;
  width: 960px;
  /* height: 324px; */
}
.NewMain .newmain_con .newmain_logo .newmain_logo_cen .newmain_logo_Img ul {
  width: 960px;
  /* height: 324px; */
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: space-between;
  justify-content: space-between;
}
.NewMain .newmain_con .newmain_logo .newmain_logo_cen .newmain_logo_Img ul li {
  width: 234px;
  height: 100px;
  text-align: center;
  padding-top: 34px;
}

.curpot{
  transition: all .6s;
  cursor: pointer;
}
.curpot:hover{
  color: #ff9203;
}

/*     display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
    justify-content: space-between; */
</style>
